import {proposalrequest} from '@mep/pae-commons';
import {Skeleton} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useQuery} from 'react-query';
import {Link} from 'react-router-dom';

import {ReactComponent as MainPartner} from '@/assets/images/main-partner.svg';
import {CACHE_KEY_LIST_USER} from '@/modules/admin/contants/users';
import useGetUserProposals from '@/modules/admin/hooks/useGetUserProposals';
import CompanyApiService from '@/modules/company/services/CompanyApiService';
import ProposalRequestStatus from '@/modules/proposalRequest/components/ProposalRequestStatus';
import {ROUTE_PATH_PROPOSAL_REQUEST} from '@/modules/proposalRequest/contants/proposalRequest';
import {useSocialDenomination} from '@/modules/proposalRequest/hooks/useSocialDenominationType';

const {PROPOSAL_STATUS} = proposalrequest;

const ProposalListItem = ({proposal, values}) => {
  const {t} = useTranslation('common');
  
  const element = useMemo(() => values?.find(e => e?._id === proposal?._id), [values, proposal?._id]);
  const isMain = useMemo(() => element?.partner?.representative, [element]);
  
  const name = useSocialDenomination(proposal);
  
  return <div className='mb-1'>
    <Link to={ROUTE_PATH_PROPOSAL_REQUEST + '/' + (proposal?.proposal || proposal?._id)} className="flex items-center">
      <ProposalRequestStatus
        status={['ACTIVE', 'DEFAULT'].includes(proposal?.status) ? PROPOSAL_STATUS.ACCEPTED : proposal?.status}
        className="mr-1 font-normal"
        hideOnNotMatch
      />
      {name || proposal?.code}
      {!!isMain && <div className="flex items-center text-primary text-xs md:ml-2">
        <MainPartner/>
        <div className="ml-1 font-normal">{t('mainPartner')}</div>
      </div>}
    </Link>
  </div>;
};

const ProposalList = ({user}) => {
  const {data, isLoading} = useGetUserProposals(user?.id);
  
  const {
    data: representative, isLoading: isLoadingRepresentative
  } = useQuery([CACHE_KEY_LIST_USER, 'representative', user?.id, user?.idNumber], async () => {
    const {data} = await CompanyApiService.isRepresentativeOn(user?.idNumber);
    return data;
  }, {enabled: !!user?.idNumber, refetchOnWindowFocus: false});
  
  if (!data?.length) return <></>;
  
  if (isLoading || isLoadingRepresentative) return <Skeleton paragraph={false} title={{className: 'm-0 mt-1'}}/>;
  
  return (<div className='text-primary text-xs italic'>
    {data?.map((p) => <ProposalListItem
      key={p?._id}
      proposal={p}
      user={user}
      values={representative}
    />)}
  </div>);
};

ProposalList.propTypes = {
  user: PropTypes.object
};

ProposalListItem.propTypes = {
  proposal: PropTypes.object, user: PropTypes.object, values: PropTypes.array
};

export default memo(ProposalList);

